import { queryKeyFn } from '../../generated/sitContext';
export const getTimesheetEntriesQueryKey = (timesheetId, includeAllocationChildren) => queryKeyFn({
    path: '/timesheets/{id}/entries',
    operationId: 'getApiTimesheetsByUuidEntries',
    variables: {
        pathParams: {
            id: timesheetId,
        },
        queryParams: includeAllocationChildren !== undefined
            ? { includeAllocationChildren }
            : {},
    },
});
export const getTimesheetEntryQueryKey = (timesheetId, entryId) => ['timesheets', timesheetId, 'entries', entryId];
//# sourceMappingURL=query-key.js.map